import * as React from 'react';

import styles from './AreaParts.css';
import { AreaPartСontrolled } from './internal/components/AreaPartControlled/AreaPartControlled';
import { AreaPartCreateBlock } from './internal/components/AreaPartCreateBlock/AreaPartCreateBlock';
import { AreaPartAddButton } from './internal/components/buttons/AreaPartAddButton/AreaPartAddButton';
import { ReturnToRegularAdBlock } from './internal/components/ReturnToRegularAdBlock/ReturnToRegularAdBlock';
import { HandleFieldChange, HandleRemove, HandleValidateField, IAreaPartsProps } from './types';
import { useSelector } from 'react-redux';
import { selectIsSaleOffer } from '../../selectors/offer/selectIsSaleOffer';

export const AreaParts: React.FC<IAreaPartsProps> = (props: IAreaPartsProps) => {
  const {
    areaParts,
    onAddBlock,
    onRemoveBlock,
    onChangeField,
    onReset,
    invalidFields,
    validateField,
    showAddButton,
    onPhotoSelect,
    uploadErrors,
    onPhotoRemove,
    onPhotoRotate,
  } = props;

  const handleRemove: HandleRemove = id => () => onRemoveBlock(id);
  const handleChangeField: HandleFieldChange = index => (field, value) => {
    onChangeField(index, field, value);
  };
  const handleValidateField: HandleValidateField = index => fieldName => {
    validateField(index, fieldName);
  };
  const isSale = useSelector(selectIsSaleOffer);

  if (areaParts == null) {
    return <AreaPartCreateBlock onClick={onAddBlock} />;
  }

  return (
    <div className={styles['container']}>
      <ReturnToRegularAdBlock onReset={onReset} />
      {areaParts.map((areaPart, idx) => (
        <div key={areaPart.id} className={styles['area-part']}>
          <AreaPartСontrolled
            id={areaPart.id}
            areaPart={areaPart}
            invalidFields={invalidFields[areaPart.id]}
            title={`Площадь ${idx + 1}`}
            isSale={isSale}
            uploadErrors={uploadErrors[idx].errors}
            canBeDeleted={areaParts.length > 2}
            onRemoveBlock={handleRemove(areaPart.id)}
            onChangeField={handleChangeField(idx)}
            onValidate={handleValidateField(idx)}
            onPhotoSelect={onPhotoSelect(idx)}
            onPhotoRemove={onPhotoRemove(idx)}
            onPhotoRotate={onPhotoRotate(idx)}
          />
        </div>
      ))}
      {showAddButton && (
        <div className={styles['add-button']}>
          <AreaPartAddButton onClick={onAddBlock} />
        </div>
      )}
    </div>
  );
};
